import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface DeleteProfileDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  profileName: string
}

export function DeleteProfileDialog({
  isOpen,
  onClose,
  onConfirm,
  profileName,
}: DeleteProfileDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Profil löschen</AlertDialogTitle>
          <AlertDialogDescription>
            Möchtest du das Profil <strong>"{profileName}"</strong> wirklich löschen?
            <br />
            <br />
            Diese Aktion kann nicht rückgängig gemacht werden. Antworten, die dieses Profil
            verwenden, werden nicht mehr weitergeleitet.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Abbrechen</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Löschen
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
